// Frontend configuration
const config = {
  // Backend URL - Replace with your actual Render backend URL
  backendUrl: process.env.REACT_APP_BACKEND_URL,
  
  // Environment
  isProduction: process.env.NODE_ENV === 'production',
  isDevelopment: process.env.NODE_ENV === 'development',
};

export default config; 